export { ProjectDetailView } from './ProjectDetailView';
export { default } from './ProjectDetailView';
